import { createAction, props } from '@ngrx/store';

import { IOrderFill, IOrderFillRequest } from '@ruby/modules/order-fill/model/order-fill.interface';
import { IError } from '@ruby/shared/models/request/error.interface';

export const loadSummary = createAction(
  '[Order Fill] Load Summary',
  props<{ data: IOrderFillRequest }>()
);

export const loadSummarySuccess = createAction(
  '[Order Fill] Load Summary Success',
  props<{ data: IOrderFill }>()
);

export const loadSummaryFailure = createAction(
  '[Order Fill] Load Summary  Failure',
  props<{ error: IError }>()
);

export const resetState = createAction('[Order Fill] Reset State');
